import React, { Component } from 'react';

class BadgePreview extends Component {
	constructor(props) {
		super(props);
		this.state = {
			scaleX: 1,
			scaleY: 1
		};
		this.badgeContainerRef = React.createRef();
		this.fieldRefs = {};
		this.qrElementRef = React.createRef();
		this.backgroundImgRef = React.createRef();
	}

	componentDidMount() {
		this.updateDisplay();
	}

	componentDidUpdate(prevProps) {
		if (prevProps.badgeConfig !== this.props.badgeConfig) {
			this.updateDisplay();
		}
	}

	updateDisplay = () => {
		const { badgeConfig } = this.props;

		if (!badgeConfig) return;

		// Update background
		if (this.badgeContainerRef.current) {
			this.badgeContainerRef.current.style.backgroundImage = badgeConfig.backgroundImage ? `url(${badgeConfig.backgroundImage})` : 'none';
			this.badgeContainerRef.current.style.backgroundSize = 'cover';
			this.badgeContainerRef.current.style.backgroundPosition = 'center';
		}

		if (this.backgroundImgRef.current) {
			this.backgroundImgRef.current.src = badgeConfig.backgroundImage || '';
			this.backgroundImgRef.current.classList.toggle('print-include', badgeConfig.includeBackground);
		}

		// Canvas dimensions: actual 88mm × 140mm at 96 PPI
		const canvasWidthPx = Math.round((88 / 25.4) * 96);   // 333px - actual 88mm at 96 PPI (rounded to whole pixels)
		const canvasHeightPx = Math.round((140 / 25.4) * 96); // 529px - actual 140mm at 96 PPI (rounded to whole pixels)

		// Scale factors: how many display pixels per real badge pixel
		const scaleX = canvasWidthPx / badgeConfig.badgeWidth;
		const scaleY = canvasHeightPx / badgeConfig.badgeHeight;

		this.setState({ scaleX, scaleY });

		// Update dynamic field positions
		if (badgeConfig.fieldsConfig) {
			badgeConfig.fieldsConfig.forEach((field, index) => {
				const element = this.fieldRefs[`field-${index}`];
				if (element) {
					element.style.top = (field.y * scaleY) + 'px';
					element.style.fontSize = field.fontSize + 'px';
					element.style.fontFamily = field.fontFamily || 'Inter, sans-serif';
					if (field.isCenter) {
						element.style.left = '0';
						element.style.width = '100%';
						element.style.textAlign = 'center';
					} else {
						element.style.left = (field.x * scaleX) + 'px';
						element.style.width = '';
						element.style.textAlign = '';
					}
				}
			});
		}

		// Update QR code position
		if (this.qrElementRef.current && badgeConfig.enableQRCode) {
			this.qrElementRef.current.style.left = (badgeConfig.qrCode.x * scaleX) + 'px';
			this.qrElementRef.current.style.top = (badgeConfig.qrCode.y * scaleY) + 'px';
			this.qrElementRef.current.style.width = (badgeConfig.qrCode.size * scaleX) + 'px';
			this.qrElementRef.current.style.height = (badgeConfig.qrCode.size * scaleY) + 'px';
			this.qrElementRef.current.style.fontFamily = 'Inter, sans-serif';
		}
	};

	render() {
		const { badgeConfig, onEdit } = this.props;

		if (!badgeConfig) {
			return (
				<div className="badge-preview-container" style={{ width: '333px', border: '1px solid #ddd', borderRadius: '8px', padding: '10px', backgroundColor: '#f9f9f9', height: '569px' }}>
					<div style={{ textAlign: 'center', marginTop: '40%' }}>
						<p style={{ color: '#666', fontSize: '14px' }}>No badge configuration available</p>
					</div>
				</div>
			);
		}

		return (
			<div className="mt-20">
				<div className='cardDetailsContainerPages containerTitle' style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '8px', width: '333px' }}>
					<div className='w-100'>
						<h2 className="blockHeader m-0" >Badge Preview</h2>
					</div>
					{onEdit && (
						<button
							className="neu   "
							onClick={onEdit}

						>
							Edit Design
						</button>
					)}
				</div>
				<div
					className="badge-container"
					ref={this.badgeContainerRef}
					style={{
						width: '333px',
						height: '529px',
						position: 'relative',
						backgroundColor: '#fff',
						overflow: 'hidden',
						border: '1px solid var(--border)',
						borderRadius: 'var(--card-border-radius)',
					}}
				>
					<img
						ref={this.backgroundImgRef}
						alt="Badge background"
						style={{
							position: 'absolute',
							top: 0,
							left: 0,
							width: '100%',
							height: '100%',
							objectFit: 'cover',
							zIndex: -1,
							display: 'block',
							visibility: badgeConfig.includeBackground ? 'visible' : 'hidden'
						}}
					/>
					{badgeConfig.fieldsConfig && badgeConfig.fieldsConfig.map((field, index) => (
						<div
							key={index}
							ref={(el) => this.fieldRefs[`field-${index}`] = el}
							style={{
								position: 'absolute',
								color: '#000',
								pointerEvents: 'none'
							}}
						>
							{field.label}
						</div>
					))}
					{badgeConfig.enableQRCode && (
						<div
							ref={this.qrElementRef}
							style={{
								position: 'absolute',
								backgroundColor: '#ccc',
								border: '1px solid #999',
								display: 'flex',
								alignItems: 'center',
								justifyContent: 'center',
								fontSize: '12px',
								color: '#666',
								pointerEvents: 'none'
							}}
						>
							QR Code
						</div>
					)}
				</div>
			</div>
		);
	}
}

export default BadgePreview;